import React, {useEffect, useState} from "react";
import {deleteResource, downloadMinioFile, getByIdResource} from "../../service/http-service";
import './ProfileSegmentStyle.css'
import DeleteModal from "../../ui/DeleteModal";
import Delete from '../../../assets/img/profile-images/Izbrisi-icon.png';
import DownloadImage from "../../../assets/img/profile-images/download.png"
import fileDownload from "js-file-download";
import {GenericEditModalForm} from "./GenericEditModalForm";

export const ProfileDocumentSegment = ({candidate, isPreview, updateCandidate, setUpdateCandidate}) => {

    const [resultListEmpty, setResultListEmpty] = useState(true);
    const [showOneElement, setShowOneElement] = useState(true);
    const [candidateExistingList, setCandidateExistingList] = useState([]);
    const [updateDocument, setUpdateDocument] = useState(false)

    const [entity, setEntity] = useState({candidate: candidate});
    const [addEntity, setAddEntity] = useState(false);
    const [updateEntity, setUpdateEntity] = useState(false)

    const [addImageEntity, setAddImageEntity] = useState(false)


    const getCandidateExistingList = () => {
        getByIdResource('candidate_documents/get_by_candidate', candidate.id).then((data) => {
            setCandidateExistingList(data.data);
            if(data.data && data.data.length > 1){
                if(isPreview){
                    setShowOneElement(false);
                }
                setResultListEmpty(false)
            } else if(data.data && data.data.length === 1){
                setResultListEmpty(false)
            }else {
                setResultListEmpty(true);
            }
        })
    }

    const downloadFile = (id, name) =>{
        downloadMinioFile('attachments/get_minio_attachment', id)
            .then((res) => {
                fileDownload(res.data, name)
            })
    };


    const confirmDelete = (data, url, refreshEntity, setRefreshEntity) => {
        deleteResource(url, data).then(() =>{
            setRefreshEntity(!refreshEntity);
            setUpdateCandidate(!refreshEntity)
        }).catch((error) => {
            console.log('error')
        })
    }

    useEffect(()=> {
        getCandidateExistingList();
    },[])

    useEffect(() => {
        getCandidateExistingList();
        setUpdateCandidate(!updateEntity);
    }, [updateEntity, updateDocument])



    return(
        <div className='profile_segment_main_container'>
            {(candidateExistingList && candidateExistingList.length > 0) &&
                candidateExistingList.map(entity =><>
                    <div className='profile_segment_separate_info d-flex justify-content-between' key={entity.id}>
                        <div><li>{entity.documentDescription}</li>
                        </div>
                        <div className="icons-div justify-self-end">
                           {!isPreview && <div className="edit_delete_icons">
                               <img className='download-image' src={DownloadImage}
                                    onClick={() => downloadFile(entity.attachmentId, entity.documentName)}/>
                                   <DeleteModal btnText={ <img src={Delete} alt="delete"/>} btnClass="apply-btn" confirmDelete={() =>
                                       confirmDelete(entity, 'candidate_documents', updateDocument, setUpdateDocument)}/>
                           </div>}
                         </div>
                      </div>
                    {!isPreview &&  <hr/>}
                    </>
                )}

            {(!addEntity && !addImageEntity && !isPreview) && (
                <div className="profile_add_button mt-3"
                     onClick={() =>
                     {setEntity({...entity, candidate: candidate})
                         setAddEntity(true)}}>Додади документ</div>)}

            {addEntity === true && (<div className="open-form"> <GenericEditModalForm
                type="DOCUMENT"
                title= {"Додади документ"}
                entity={entity} setEntity={setEntity}
                addEntity={addEntity} setAddEntity={setAddEntity}
                updateEntity={updateEntity} setUpdateEntity={setUpdateEntity}/></div>)}
            {!resultListEmpty && <hr/>}
        </div>
    )
}